import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { FarmAlertsPageRoutingModule } from './farm-alerts-routing.module';
import { FarmAlertsPageComponent } from './farm-alerts.page';

@NgModule({
  declarations: [FarmAlertsPageComponent],
  imports: [CommonModule, FormsModule, IonicModule, FarmAlertsPageRoutingModule, ReactiveFormsModule, MiscModule]
})
export class FarmAlertsPageModule {}
